import { Component, OnInit, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { AuthService } from '../../services/auth.service';


export class LoginComponent implements OnInit {
  f: FormGroup;
  authError: string | null;
  loading = false;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
     private authService: AuthService
  ) { }

  ngOnInit() {
    // reset login status
    this.authService.logout();

    this.f = this.formBuilder.group({
      'username': ['', Validators.required],
      'password': ['', Validators.required]
    });
  }

  isInvalid(control : FormControl): boolean {
    return control && control.touched && !control.valid;
  }

  errorClass(control : FormControl): any {
    const condition = this.isInvalid(control);
    return {
      'has-error': condition,
      'has-feedback': condition
    };
  }

  login() {
    if (this.f.dirty && this.f.valid) {
      this.loading = true;
      const username = this.f.value.username, password = this.f.value.password;

      this.authService.login(username, password)
        .subscribe((userData : any) => {
          this.loading = false;

          // navigate to returnUrl just if login successfully
          if (userData.access_token) {
            this.router.navigate([this.route.snapshot.queryParams['returnUrl'] || '/']);
          } else {
            this.showAuthError('Token not sent from service during authentication.');
          }
        }, (error : any) => {
          this.showAuthError('The user is not authorized');
          this.loading = false;
        });
    }
  }

  showAuthError(message : string) {
    const that = this;
    this.authError = message;
    setTimeout(function () {
      that.authError = null;
    }, 1000);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'app-login',
  template: `
  <div class="col-md-6 col-md-offset-3">
      <h2>Login</h2>
      <form [formGroup]="f" (ngSubmit)="login()" novalidate>
          <div *ngIf="authError" id="message" role="alert" class="alert alert-danger"><i class="fa fa-remove"></i> {{authError}}</div>
          <div class="form-group" [ngClass]="errorClass(f.controls.username)">
              <label for="username">User name:</label>
              <input type="text" class="form-control" id="username" formControlName="username" placeholder="Enter user name ...">
              <span *ngIf="isInvalid(f.controls.username)" class="glyphicon glyphicon-remove form-control-feedback"></span>
              <leaf-layout-control-messages [formControl]="f.controls.username" [message]="'Username is required!'"></leaf-layout-control-messages>
          </div>
          <div class="form-group" [ngClass]="errorClass(f.controls.password)">
              <label for="pwd">Password:</label>
              <input type="password" class="form-control" id="pwd" formControlName="password" placeholder="Enter password ...">
              <span *ngIf="isInvalid(f.controls.password)" class="glyphicon glyphicon-remove form-control-feedback"></span>
              <leaf-layout-control-messages [formControl]="f.controls.password" [message]="'Password is required!'"></leaf-layout-control-messages>
          </div>
          <div class="form-group">
              <button type="submit" class="btn btn-primary" [disabled]="(f.dirty && !f.valid) || loading">Login</button>
              <img *ngIf="loading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
          </div>
      </form>
  </div>
  `
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: FormBuilder, },
{type: ActivatedRoute, },
{type: Router, },
{type: AuthService, decorators: [{ type: Inject, args: ['AuthService', ] }, ]},
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
